// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p{
    font-size: 1.75em;
    font-weight: bold;
}

.message {
    padding: 50px;
}


.browse:hover {
    background-color:#666 !important;
  }`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
